import { useSearchParams } from 'react-router-dom';
import {
  UnAuthorized,
  PaymentRequired,
  CannotChangePlan,
  CannotPublishPage,
} from './errorType';

import UnAuthorizedPage from './UnAuthorizedError';
import PaymentRequiredPage from './PaymentRequired';
import CannotChangePlanErrorPage from './CannotChangePlan';
import CannotPublishPagePage from './CannotPublishPage';

const ErrorPage = () => {
  const [searchParams] = useSearchParams();
  const errorType = searchParams.get('type');

  return (
    <>
      {(errorType === UnAuthorized) && <UnAuthorizedPage />}
      {(errorType === PaymentRequired) && <PaymentRequiredPage />}
      {(errorType === CannotChangePlan) && <CannotChangePlanErrorPage />}
      {(errorType === CannotPublishPage) && <CannotPublishPagePage />}
    </>
  );
};

export default ErrorPage;
